import { ModuleConditionalRoute, RouteConditions, StepConditionalRoute } from '@/types/route'
import { conditionsMatch } from '@/utils/conditions'

export const getRouteByConditions = <T extends ModuleConditionalRoute | StepConditionalRoute>({
  userConditions,
  routes
}: {
  userConditions?: RouteConditions
  routes: T[]
}): T => {
  if (!userConditions) throw new Error('No user conditions provided')
  if (!routes || routes.length === 0) throw new Error('No routes provided')

  const routesMatching = routes.filter((route) => {
    const { conditions: routeConditions } = route
    return conditionsMatch({ userConditions, routeConditions })
  })

  let validRoutes = null
  if (routesMatching.length > 0) {
    // Sort routes by number of conditions
    validRoutes = routesMatching.sort((a, z) => {
      const aConditions: number = a.conditions ? Object.keys(a.conditions).length : 0
      const zConditions: number = z.conditions ? Object.keys(z.conditions).length : 0

      return zConditions - aConditions
    })
  } else {
    // Filter routes without conditions
    validRoutes = routes.filter((route) => !route.conditions)
  }

  if (!validRoutes) throw new Error('No route found with conditions')

  // Return the first route (most conditions or no conditions)
  return validRoutes[0]
}
